export default __webpack_public_path__ + "static/media/hem.2324a25f.png";